import React, { useEffect } from "react";
import { Layout } from "antd";
import axios from "axios";

const { Content } = Layout;

const AddPermission = () => {
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = (filter) => {
        axios
            .post(
                process.env.REACT_APP_BASE_URL + "/api/1.0/permission/list",
                { filter },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem("token"),
                    },
                }
            )
            .catch((e) => {
                console.error('Fetch Permissions: ', e);
            });
    };

    return <Content/>;
};

export default AddPermission;
